<script lang="ts" setup>
import { APP_VERSION } from '@/constants';
</script>

<template>
  <div class="layout-wrapper">
    <!-- Include any global elements like headers or footers if needed -->
    <slot />
    <!-- Page Footer -->
    <div id="footer">
      <p class="copyright">&#169; Sampling Human, Inc. All Rights Reserved.</p>
      <p class="links">
        <!-- Open www.samplinghuman.com terms and conditions and privacy policy in new tab -->
        <a
          href="https://www.samplinghuman.com/terms-and-conditions"
          target="_blank"
          rel="noopener noreferrer"
        >
          Terms and Conditions
        </a>
        <!-- enabled by uncommenting once Privacy Policy is published 
          |
          <a
            href="https://www.samplinghuman.com/privacy-policy"
            target="_blank"
            rel="noopener noreferrer"
          >
            Privacy Policy
          </a>-->
        <!-- Deprecated original terms and conditions, privacy policy and cloud terms routes 
        <RouterLink :to="{ name: 'TermsAndConditions' }"
          >Terms and Conditions</RouterLink
        >
        |
        <RouterLink :to="{ name: 'PrivacyPolicy' }">Privacy Policy</RouterLink>
        | <RouterLink :to="{ name: 'CloudTerms' }">Cloud Terms</RouterLink
        >-->
        <br />
        {{ APP_VERSION }}
        <br />
      </p>
    </div>
  </div>
</template>

<style>
.layout-wrapper {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}
.layout-wrapper > *:first-child {
  flex: 1 0 auto;
}
#landing-page {
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
}
#landing-content {
  margin-block: auto auto; /* auto top margin pushes it down to mid-line   */
  text-align: center;
  color: rgba(255, 255, 255, 0.75);
}
#landing-content h1 {
  margin-top: 1rem;
  font-size: 10rem;
}
#landing-content h2 {
  font-size: 1rem;
  margin-bottom: 3rem;
}
#landing-content img.logo {
  width: 150px;
  height: auto;
  margin-bottom: 10px;
}
/* BUTTONS AND LINKS */
#landing-content button.enter {
  background-color: rgba(255, 255, 255, 0.5);
  color: darkslategray;
  border: none;
  padding: 10px 200px;
  font-size: 1em;
  border-radius: 10px;
  cursor: pointer;
}
#landing-content button.enter:hover {
  background-color: rgba(255, 255, 255, 0.75);
  font-weight: bold;
}
#landing-content a {
  color: rgba(255, 255, 255, 0.75);
  text-decoration: none;
}
#landing-content a:hover {
  font-weight: bold;
  text-decoration: none;
}
p.links {
  padding: 0;
  margin: 0;
  color: rgba(255, 255, 255, 0.75);
  font-size: 0.7em;
}
p.links a {
  font-size: 1em;
}

/* FOOTER */
#footer {
  padding-bottom: 1rem;
  margin-top: 1rem;
  text-align: center;
  font-size: 0.75rem;
  margin-top: auto; /* push to the bottom if content short */
  color: rgba(255, 255, 255, 0.75);
}
#footer p.copyright {
  margin-top: 2rem;
  margin-bottom: 0;
}
#footer p.links {
  color: rgba(255, 255, 255, 0.75);
}
#footer p.links a {
  color: rgba(255, 255, 255, 0.75);
}

/* RESPONSIVE */
@media screen and (max-width: 700px) {
  #landing-content button.enter {
    padding: 8px 100px;
  }
}
@media screen and (max-width: 500px) {
  #landing-content h1 {
    margin-top: 1rem;
    font-size: 7.5rem;
  }
  #landing-content h2 {
    font-size: 0.75rem;
    margin-bottom: 3rem;
  }
  #landing-content button.enter {
    padding: 5px 50px;
  }
}
@media screen and (max-height: 500px) {
  #landing-content h1 {
    margin-top: 0.25rem;
    font-size: 7.5rem;
  }
  #landing-content h2 {
    font-size: 0.75rem;
    margin-bottom: 1rem;
  }
}
</style>
